var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14257",
    "data-name": "Group 14257",
    transform: "translate(-1354 -287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5490",
    "data-name": "Rectangle 5490",
    transform: "translate(1354 287)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "icons8-upload-to-cloud",
    d: "M17.628,4.531a7.945,7.945,0,0,0-7.142,4.578,4.185,4.185,0,0,0-2.374-.817,4.227,4.227,0,0,0-4.2,4.027A5.833,5.833,0,0,0,5.87,23.66h5.072a.608.608,0,1,0,0-1.216H5.87a4.662,4.662,0,0,1-1.235-9.156.608.608,0,0,0,.437-.608c0-.085,0-.128,0-.133a3.049,3.049,0,0,1,5.2-2.147.608.608,0,0,0,.988-.209A6.78,6.78,0,0,1,24.41,12.528a6.681,6.681,0,0,1-.057.836.608.608,0,0,0,.589.684h.038a4.2,4.2,0,1,1,0,8.4H19.452a.608.608,0,1,0,0,1.216h5.528a5.424,5.424,0,0,0,5.414-5.414,5.358,5.358,0,0,0-4.806-5.281c.009-.147.038-.285.038-.437A8.01,8.01,0,0,0,17.628,4.531ZM15.2,14.9l-.437.418L11.72,18.36a.618.618,0,0,0,.874.874l1.995-1.995V27.915a.608.608,0,1,0,1.216,0V17.239L17.8,19.234a.618.618,0,0,0,.874-.874l-3.039-3.039Z",
    transform: "translate(1355 287.469)",
    fill: "#fd7422",
    stroke: "#fd581f",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadOrange);
export default __webpack_public_path__ + "static/media/upload_orange.4dd3fd81e6926bcc2a378bb9ce871280.svg";
export { ForwardRef as ReactComponent };